import {Controller} from 'stimulus'
import {confetti} from "dom-confetti";

export default class extends Controller
  @targets = [
    'usernameInput'
    'emailInput'
    'detectedEmailInput'
    'nameInput'
    'planInput'
    'plans'
    'plan'
    'form'
    'cardElement'
    'requestButton'
    'submitButton'
    'confettiPin',
    'secureNotice',
    'affiliatePromoContainer',
    'affiliateHtml',
    'alreadySubscribed',
    'sourceInput',
    'agreeInput'
  ]

  chosenPlanCode: null
  chosenPlanName: null
  chosenPlanPrice: null
  
  stripeInitialized: false

  connect: ->
    if @element.dataset.defaultPlan?
      if @planExists(@element.dataset.defaultPlan)
        @selectPlan(@element.dataset.defaultPlan)
      else
        @selectPlan('monthly')
    else
      @selectPlan('monthly')
      
    @initializeStripe()
  
  handlePlanClick: (e) ->
    @selectPlan(e.currentTarget.dataset.code)
  
  planValue: -> @planInputTarget.value
  username: -> @usernameInputTarget.value
  name: -> @nameInputTarget.value
  email: -> @emailInputTarget.value
  detectedEmail: -> @detectedEmailInputTarget.value
  sourceValue: -> @sourceInputTarget.value

  planExists: (code) -> @plansTarget.querySelector("[data-code='#{code}']")?
  selectPlan: (code) -> 
    @chosenPlanCode = code
    
    @planInputTarget.value = @chosenPlanCode

    @planTargets.map (element) => element.classList.remove 'active'
    
    planElement = @planTargets.find (element) => element.dataset.code == @chosenPlanCode
    return alert("Invalid plan") unless planElement

    planElement.classList.add 'active'

    @chosenPlanName = planElement.dataset.name
    @chosenPlanPrice = parseFloat(planElement.dataset.price)

    @updateStripeValues()


  # Get Stripe ready
  initializeStripe: ->
    options = if !!STRIPE_ACCOUNT_ID then {stripeAccount: STRIPE_ACCOUNT_ID} else null
    @stripe = new Stripe(STRIPE_PUBLISHABLE_KEY, options)
    @elements = @stripe.elements()

    @createCardPayment()
    @createPaymentRequestButton()

    @emailInputTarget.addEventListener 'change', () => @updateStripeValues()

    @formTarget.addEventListener 'submit', @handleStripeSubmit.bind(@)

    @stripeInitialized = true

  # Create card input box
  createCardPayment: ->
    @card = @elements.create('card', style: @stripeStyles(), hidePostalCode: false)
    @card.mount('#card-element')

    @card.on 'change', ({error}) =>
      errorsContainer = @stripeErrors()
      if error
        errorsContainer.innerText = error.message
        @submitButtonTarget.disabled = true
      else
        errorsContainer.innerText = ''
        @submitButtonTarget.disabled = false


  # Create google pay / apple pay button
  createPaymentRequestButton: ->
    @paymentRequest = @stripe.paymentRequest(
      country: 'US'
      currency: 'usd'
      total:
        label: @chosenPlanName
        amount: parseInt(@chosenPlanPrice * 100)
      requestPayerEmail: true
      requestPayerName: true
    )

    @prButton = @elements.create('paymentRequestButton', {
      paymentRequest: @paymentRequest
    })

    @paymentRequest.canMakePayment().then (result) =>
      if result
        @prButton.mount('#payment-request-button')
      else
        document.getElementById('payment-request-button').style.display = 'none';

    @paymentRequest.on 'paymentmethod', (ev) =>
      # Request client secret from server
      data = 
        checkout:
          email: @email() || ev.payerEmail
          detected_email: @detectedEmail()
          username: @username()
          name: @name() || ev.payerName
          plan: @planValue()
          source: @sourceValue()

      fetch(@element.dataset.subscribeUrl, 
        method: 'POST'
        headers: 'Content-Type': 'application/json'
        body: JSON.stringify(data)
      )
        .then (res) => res.json()
        .then (json) => 
          if json.already_subscribed
            @alreadySubscribedTarget.classList.remove('hidden')
            @alreadySubscribedTarget.innerHTML = json.already_subscribed_html
            ev.complete('success')
            return

          @alreadySubscribedTarget.classList.add('hidden')

          @stripe.confirmCardPayment(json.client_secret,
            {payment_method: ev.paymentMethod.id},
            {handleActions: false}
          ).then (confirmResult) =>
            if confirmResult.error
              ev.complete('fail')
            else
              ev.complete('success')

              if confirmResult.paymentIntent.status == "requires_action"
                @stripe.confirmCardPayment(json.client_secret)
                  .then (result) =>
                    if result.error
                      alert "Verification failed. Please try again or use a different payment method."
                    else
                      @handleSuccess(json)
              else
                @handleSuccess(json)
        

  # Update stripe values on email / plan change
  updateStripeValues: ->
    return unless @stripeInitialized

    @paymentRequest?.update(
      total:
        label: @chosenPlanName
        amount: parseInt(@chosenPlanPrice * 100)
    )

  agreed: -> @agreeInputTarget.checked

  handleStripeSubmit: (e) ->
    e.preventDefault()

    # if !@name()
    #   alert("Please enter your full name. We need it for billing purposes and we don't store it on our servers. It stays anonymous all the time.")
    #   return false

    # if !@agreed()
    #   alert("Please agree to the terms of service and privacy policy.")
    #   return false

    @originalSubmitButtonHTML = @submitButtonTarget.innerHTML
    @submitButtonTarget.disabled = true
    @submitButtonTarget.innerHTML = "Activating..."
    @stripeErrors().innerText = ''

    # Request client secret
    data = 
      checkout:
        email: @email()
        detected_email: @detectedEmail()
        username: @username()
        name: @name()
        plan: @planValue()
        source: @sourceValue()

    fetch(@element.dataset.subscribeUrl, 
      method: 'POST'
      headers: 'Content-Type': 'application/json'
      body: JSON.stringify(data)
    )
      .then (res) => res.json()
      .then (json) => 
        # If subscription is already_subscribed - render link to manage billing
        if json.already_subscribed
          @alreadySubscribedTarget.classList.remove('hidden')
          @alreadySubscribedTarget.innerHTML = json.already_subscribed_html
          @submitButtonTarget.disabled = false
          @submitButtonTarget.innerHTML = @originalSubmitButtonHTML
          return
        
        @alreadySubscribedTarget.classList.add('hidden')

        # Otherwise - continue with payment
        stripeClientSecret = json.client_secret

        if json.is_setup
          return @handleSetup(json)

        @stripe.confirmCardPayment(stripeClientSecret,
          payment_method:
            card: @card
            billing_details:
              name: @name()
              email: @email()
          setup_future_usage: 'off_session'
        ).then((result) => console.log(result); @handleCardResult(result, json))
          .catch((error) => console.error(error))
      .catch () =>
        @submitButtonTarget.disabled = false
        @submitButtonTarget.innerHTML = @originalSubmitButtonHTML

  handleCardResult: (result, json) ->
    if result.error
      @submitButtonTarget.disabled = false
      @submitButtonTarget.innerHTML = @originalSubmitButtonHTML
      @stripeErrors().innerText = result.error.message
    else if result.paymentIntent.status == 'succeeded'
      @submitButtonTarget.innerHTML = 'Activated!'
      @submitButtonTarget.classList.remove 'btn-onlyfans'
      @submitButtonTarget.classList.add 'btn-success'
      @handleSuccess(json)

  stripeErrors: -> document.getElementById('stripe-errors')
  stripeSuccess: -> document.getElementById('stripe-success')
  handleSuccess: (json) ->
    @trackPurchaseConversion(json.transaction_id)
    @stripeSuccess().innerText = "Thank you, your access will be available soon! Refresh onlyfans.com in 1-2 minutes please ..."
    @showConfetti()
    @hideCardElement()
    @renderAffiliatePromo(json.affiliate_html)
    # setTimeout(=>
      # Turbo.visit(@element.dataset.successUrl)
    # , 1000)

  trackPurchaseConversion: (transactionId) ->
    console.log 'tracking Purchase Conversion', transactionId
    gtag? && gtag('event', 'conversion', {
      'send_to': 'AW-320170390/wSUuCLKgzZYDEJbT1ZgB',
      'value': parseFloat(@chosenPlanPrice),
      'currency': 'USD',
      'transaction_id': transactionId
    });

  handleSetup: (json) ->
    @stripe.confirmCardSetup(json.client_secret, {
      payment_method:
        card: @card
        billing_details:
          name: @name()
          email: @email()
    }).then((result) => @handleSetupResult(result, json))

  handleSetupResult: (result, json) ->
    if result.error
      @submitButtonTarget.disabled = false
      @submitButtonTarget.innerHTML = @originalSubmitButtonHTML
      @stripeErrors().innerText = result.error.message
    else
      @submitButtonTarget.innerHTML = 'Activated!'
      @submitButtonTarget.classList.remove 'btn-onlyfans'
      @submitButtonTarget.classList.add 'btn-success'
      @handleSuccess(json)

  hideCardElement: ->
    @cardElementTarget.classList.add 'hidden'
    @secureNoticeTarget.classList.add 'hidden'

  renderAffiliatePromo: (html) ->
    @affiliatePromoContainerTarget.classList.remove 'hidden'
    @affiliateHtmlTarget.innerHTML = html

  showConfetti: ->
    confetti(@confettiPinTarget)

  stripeStyles: ->
    base:
      color: '#454f5b'
      fontFamily: '"-apple-system", "BlinkMacSystemFont", "San Francisco", "Roboto", "Segoe UI", "Helvetica Neue", sans-serif'
      fontSmoothing: 'antialiased'
      fontSize: '17px'
      '::placeholder': color: '#637381'
    invalid:
      color: '#212b36'
      iconColor: '#bf0812'